import { useToast as useChakraToast } from '@chakra-ui/react';
import { TOAST_MARGIN_LEFT } from 'constants/editor';
import { useCallback } from 'react';

import { ToastContent, ToastOptionProps } from './ToastLayout';

export const useToast = (options?: ToastOptionProps) => {
  const toast = useChakraToast({
    position: 'bottom-left',
    containerStyle: { marginLeft: TOAST_MARGIN_LEFT },
    duration: 4000,
    isClosable: false,
    status: 'success',
    render: ({ title, description, status, icon, enableProgress }: ToastOptionProps) => {
      return (
        <ToastContent
          title={title}
          description={description}
          status={status}
          enableProgress={enableProgress}
          icon={icon}
        />
      );
    },
    ...options,
  });

  // the toast is wrapped in a callback else it will be re-declared on every render
  // should be safe to skip the dependiences as the toast is only created once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(toast, []);
};
